import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useLayout } from "../contexts/layoutContext";
import {
  TAB_BAR_ITEMS,
  isRouteActive,
  isMoreRouteActive,
} from "../config/navigation";
import MobileMoreMenu from "./MobileMoreMenu";
import "./MobileTabBar.css";

const MobileTabBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { showTabBar, openMoreMenu, moreMenuOpen } = useLayout();

  if (!showTabBar) return null;

  const handleTabPress = (item) => {
    if (item.isMore) {
      openMoreMenu();
      return;
    }
    navigate(item.route);
  };

  return (
    <>
      <nav className="mobile-tab-bar" aria-label="Navegación principal">
        <ul className="mobile-tab-bar-list">
          {TAB_BAR_ITEMS.map((item) => {
            if (!item) return null;

            const Icon = item.icon;
            const isMore = Boolean(item.isMore);
            const active = isMore
              ? moreMenuOpen || isMoreRouteActive(location.pathname)
              : isRouteActive(location.pathname, item.route);

            return (
              <li key={item.isMore ? "more" : item.route} className="mobile-tab-bar-item">
                <button
                  type="button"
                  onClick={() => handleTabPress(item)}
                  aria-label={item.label}
                  aria-current={active ? "page" : undefined}
                  className={`mobile-tab-bar-btn ${active ? "mobile-tab-bar-btn--active" : ""}`}
                >
                  <Icon size={24} className="mobile-tab-bar-icon" aria-hidden />
                  <span className="mobile-tab-bar-label">{item.shortLabel || item.label}</span>
                </button>
              </li>
            );
          })}
        </ul>
      </nav>

      <MobileMoreMenu />
    </>
  );
};

export default MobileTabBar;
